import { JsmInvocation } from '@app/booking-types/types';
import { useEffect, useState } from 'react';
import { JiraFromUI } from '@app/booking-frontend-libs';
import { Logger } from '@app/booking-libs';
import { useUserContext } from './useUserContext';
import { invoke } from '@forge/bridge';
import { fromJiraFieldsToBookingFields } from '../../libs/fromJiraFieldsToBookingFields';
const log = new Logger('useBookingFormFields');
export function useBookingFormFields(config) {
    const { userIsLoaded, unlicensed } = useUserContext();
    const [fields, setFields] = useState({});
    const [loadingFields, setLoadingFields] = useState(true);
    const [errors, setErrors] = useState([]);
    useEffect(() => {
        if (config && userIsLoaded) {
            setLoadingFields(true);
            if (!unlicensed) {
                // normal Jira user (licensed)
                JiraFromUI.getCreationFields(config.projectId, config.issuetypeId).then((jiraFields) => {
                    const { errors, fields } = fromJiraFieldsToBookingFields(config, jiraFields);
                    setFields(fields);
                    setErrors(errors);
                    setLoadingFields(false);
                });
            }
            else {
                // anonymous or JSM customer (unlicensed)
                const payload = { config };
                invoke(JsmInvocation.getFormFields, payload).then((response) => {
                    if (!response.success) {
                        log.error('Unable to fetch form fields', response.message);
                        setErrors([response.message]);
                    }
                    else {
                        setFields(response.payload.fields);
                    }
                    setLoadingFields(false);
                });
            }
        }
    }, [config, userIsLoaded, unlicensed]);
    return {
        loadingFields,
        fields,
        errors
    };
}
